export const PLAUSIBLE_GOAL_KEYS = {
  VENUE_WHATSAPP_CLICK_EVENT: 'click_venue_whatsapp_button',
  VENUE_CALL_CLICK_EVENT: 'click_venue_call_button',
  CLICK_QUOTE_EVENT: 'click_quote_button',
  REQUEST_QUOTE_COMPETED_EVENT: 'request_quote_completed',
  REQUEST_QUOTE_FAILED_EVENT: 'request_quote_failed',
  SEARCH_MODAL_OPENED: "search_modal_opened",
  SEARCH_MODAL_CLOSED: "search_modal_closed",
  SEARCH_INPUT_OPENED: "search_input_opened",
  SEARCH_INPUT_CLOSED: "search_input_closed",
  SEARCH_DROPDOWN_ITEM_CLICKED: "search_dropdown_item_clicked",
  SEARCH_MODAL_BUTTON_CLICKED: "search_modal_button_clicked"
}

export const CLICK_QUOTE_EVENT_SECTIONS = {
  HOMEPAGE_FIRST_SCREEN: 'homepage-first-screen',
  VENUE_CARD: 'venue-card',
  BLOG_DETAIL: 'blog-detail',
  WORKERS_PAGE: 'workers-page',
  LIST_PAGE_HEADER_SECTION: 'list-page-header-section',
  VENUE_DETAIL_HEADER_SECTION: 'venue-detail-header-section',
  SIDEBAR: 'sidebar',
  CONTACT_MODAL: 'contact-modal',
  BOTTOM_BAR: 'bottom-bar',
  MOBILE_BULK_OFFER: 'mobile-bulk-offer',
  DESKTOP_BULK_OFFER: 'desktop-bulk-offer',
  FAVORITE_VENUES: 'favorite-venues-page'
}